import { DropDownList } from "@progress/kendo-react-dropdowns";
import { GridCell } from "@progress/kendo-react-grid";
import React from "react";
export default class NewApprovedCheckBox extends GridCell {

    handleChange(e) {
        this.props.onChange({
            dataItem: this.props.dataItem,
            field: this.props.field,
            syntheticEvent: e.syntheticEvent,
            value: e.target.value,
        });
        if (this.props.field && this.props.field === this.props.dataItem.inEdit &&
            this.props.dataItem.riskRegisterActionId) {
            let updateData = {
                ...this.props.dataItem, 'text': e.target.value.text,
                'value': e.target.value.value
            }
            this.props.updateDropdownValue(updateData);
        }
    }
    handleEditCell = () => {
        this.props.onEditCell(this.props.dataItem, this.props.field)
    }
    render() {
        const value = this.props.dataItem[this.props.field];
        const selectedValue = value
            ? this.props &&
            this.props.dropDownData.find((item) => item.value === value)
            : "";
        if ((this.props.field && this.props.field === this.props.dataItem.inEdit) || this.props.dataItem.inEdit === true) {
            return (
                <td>
                    <DropDownList
                        style={ { width: "100px" } }
                        onChange={ this.handleChange.bind(this) }
                        value={ selectedValue ? selectedValue : value }
                        data={ this.props ? this.props.dropDownData : [] }
                        valueField="value"
                        textField="text"
                    />
                </td>
            );
        }
        if (this.props.dataItem.inEdit !== this.props.field) {
            return (
                <td onClick={ this.handleEditCell } className="k-grid-content-sticky" style={ { left: '0px', right: '150px' } }>
                    {" " }
                    {value === null || value == undefined
                        ? ""
                        :
                        value.text
                            ? value.text
                            : value ? "Yes" : "No" }
                </td>
            );
        }
    }
}
